import { Children, isValidElement } from 'react';
const DATA_SLOT = 'data-slot';
/**
 * Obtain all children that are annotated with a given slot.
 *
 * @param children - The children being filtered.
 * @param slot - The slot to search for.
 */
function getSlot(children, slot) {
    return Children.toArray(children)
        .filter(child => {
        if (!isValidElement(child)) {
            return false;
        }
        const childSlot = child.props.slot ?? child.props[DATA_SLOT];
        return childSlot === slot;
    });
}
export { getSlot, };
//# sourceMappingURL=get-slot.js.map